import moment from 'moment';
import { UseFormWatch } from 'react-hook-form';

import { CampaignFormValues } from './saveCampaign.hook';

export const inferSessionStartDate = (watch: UseFormWatch<CampaignFormValues>, session: number): string => {
  const { disabledDates, enabledWeekDays, launchDate, orderedSessions, nbSessions } = watch();

  const totalSessions = orderedSessions?.length || nbSessions;

  if (!totalSessions || !enabledWeekDays?.length) {
    return launchDate || moment().startOf('day').toString();
  }

  let dateIterator: moment.Moment | string = moment(launchDate).startOf('day').subtract(1, 'days');
  let currentSession = 0;

  while (currentSession < session) {
    dateIterator = moment(dateIterator).add(1, 'days').format('YYYY-MM-DD');

    const isDayDisabled =
      disabledDates?.indexOf(dateIterator) !== -1 || enabledWeekDays?.indexOf(moment(dateIterator).isoWeekday()) === -1;

    if (!isDayDisabled) {
      currentSession += 1;
    }
  }

  return moment(dateIterator).startOf('day').toString();
};
